import { graphql, useStaticQuery } from 'gatsby';

const usePdpPageData = () => {
  const { allContentfulPdpPage, allReviews } = useStaticQuery(graphql`
    query {
      allContentfulPdpPage(filter: { title: { ne: "Thyroid Test-new" } }) {
        nodes {
          title
          canonicalUrl
          metaTitle
          metaDescription {
            metaDescription
          }
          metaKeywords {
            metaKeywords
          }
          productSchema {
            name
            description
          }
          faqSchema {
            question
            answer
          }
          heroDescriptionHeader
          heroDescriptionText {
            heroDescriptionText
          }
          heroMeasuresText
          heroMeasuresIcon {
            file {
              url
            }
          }
          consultAvailable
          consultAvailableText
          heroPurchaseDetailsCallout
          heroSliderImages {
            description
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
          heroBottomCallout
          heroDescriptionCallout
          heroMeasuresContentSection {
            listOfContentSections {
              title
              description {
                description
              }
              image {
                gatsbyImageData(placeholder: BLURRED, quality: 75)
                file {
                  url
                }
              }
            }
          }
          heroModalButtonText
          heroModalTitle
          hideSubscription
          preSelectedSubscription
          heroSubscriptionFaqUrl
          pageSections {
            title
            sectionId
            headline
            subHeadline
            componentName
            listOfContentSections {
              sectionId
              headline
              slug
              subHeadline
              title
              description {
                description
              }
              cta {
                text
                url
              }
              image {
                description
                gatsbyImageData(placeholder: BLURRED, quality: 75)
                file {
                  url
                }
              }
              desktopImages {
                title
                description
                gatsbyImageData(placeholder: BLURRED, quality: 75)
                file {
                  url
                }
              }
              mobileImages {
                title
                description
                gatsbyImageData(placeholder: BLURRED, quality: 75)
                file {
                  url
                }
              }
              embeddedVideoLink
              modalButtonText
              modalTitle
              slug
              listOfContentSections {
                title
                image {
                  file {
                    url
                  }
                  gatsbyImageData(placeholder: BLURRED, quality: 75)
                }
                description {
                  description
                }
                cta {
                  text
                  url
                }
              }
            }
            noNumberTags
            cta {
              text
              url
            }
            description {
              description
            }
            desktopImages {
              description
              gatsbyImageData(placeholder: BLURRED, quality: 75)
            }
            mobileImages {
              description
              gatsbyImageData(placeholder: BLURRED, quality: 75)
            }
            modalButtonText
          }
          product {
            slug
            productId
            displayName
            description
            onSale
            outOfStock
            promoText
            category {
              title
            }
            primaryCallouts {
              ... on ContentfulPrimaryCallout {
                text
              }
            }
            collectionMethods {
              ... on ContentfulCollectionMethod {
                v2Name
                v2Icon {
                  file {
                    url
                  }
                }
              }
            }
            markerList {
              title
              markers {
                title
                description {
                  description
                }
              }
            }
            digDeeperSections {
              question
              answer {
                answer
              }
            }
            heroImages {
              description
              gatsbyImageData(placeholder: BLURRED, quality: 75)
            }
          }
          disclaimer {
            title
            body {
              raw
            }
            callToAction {
              url
              text
            }
          }
          screener {
            options {
              items
              label
              value
            }
            callToActionText
            title
          }
        }
      }
      allReviews {
        nodes {
          product_name
          product_page_id
          average_rating
          native_review_count
          question_count
          rating_histogram
          recommended_ratio
          review_count
          syndicated_review_count
        }
      }
    }
  `);
  return { allContentfulPdpPage, allReviews };
};
export default usePdpPageData;
